<template>
  <span v-tooltip="{ data:  'Multi search' , arrowPosition: 'right'}">
    <Button :empty="empty" @click.prevent="onFilesChosen"  >
      <template>{{  'Track Comparison' }}</template>
    </Button>
    <input
      style="display:none"
      ref="uploadField"
      id="upl"
      type="file"
      :accept="acceptedFiles"
      @change="startUpload"
    />
    <UploadFile
      ref="fileModal"
      @confirmed="onUploadClick"
    ></UploadFile>
  </span>
</template>
<script>
import EventBus from "@/eventbus";
import Button from "@/components/common/Button.vue";
import {mapActions, mapState} from "vuex";
import UploadFile from "./UploadFile.vue";
import Constants from "@/store/constants";
import store from "@/store";
import { HTTP } from "@/utils/http";
export default {
  name: "UploadMultiSearchButton",
  store,
  extends: Button,
  components: {UploadFile},

  props: {
    empty: Boolean
  },
  data() {
    return {
      filesToUpload: [],
      fileType: null,
      acceptedFiles: Constants.acceptedFiles
    };
  },
  computed: {
  },
  created() {

  },
  methods: {

    startUpload(event) {
      this.filesToUpload = event.target.files[0];
      const data = new FormData();
      data.append("StationUid", this.$route.params.stationUid);
      data.append("File", this.filesToUpload);
      HTTP.post('api/multi-search/create-file', data)
          .then((response) => {
            this.$store.dispatch('Toasts/addToast', {
              title: 'Success',
              message: 'File successfully updated',
              delay: 1500,
              type: 'success'
            });
          })
          .catch(err => {
            console.log(err)
            this.$store.dispatch('Toasts/addToast', {
              title: 'Error',
              message: `An error occurs while uploading file : ${err}`,
              type: 'danger'
            });
          });

    },
    onFilesChosen() {
      if (!this.$refs.uploadField) return;
     // this.filesToUpload = Array.from(this.$refs.uploadField.files);
     // console.log(this.filesToUpload)
      this.$refs.fileModal.show();
      this.$refs.uploadField.value = null;

    },
    onUploadClick() {
      if (!this.$refs.uploadField) return;
      this.$refs.uploadField.click();
    }

  }
}

</script>

<style scoped>
</style>
